module.exports = __webpack_public_path__ + "components/flag/static/square/er-a0e0292a31c54b2cb0b754dedab11639.svg";